/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';

const accessTypeApi = async (): Promise<any> => {
  const accessTypes = useJSONStore.getState().accessTypes;
  const token = useUserStore.getState().userToken;
  const setAccessTypes = useJSONStore.getState().setAccessTypes;

  if (accessTypes.length === 0) {
    await axios
      .request({
        method: CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.JSON.accessType}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {},
        data: {}
      })
      .then((res) => {
        setAccessTypes(res.data.data);
      })
      .catch((err) => {
        return err.message;
      });
  }
};

export default accessTypeApi;
